import { Wrapper } from '@american-autonomy/ag-ui';

import EmptyState from 'components/EmptyState';

import BatteryCard from 'pages/MaintenancePage/components/BatteryCard';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const BatteryCardGrid: FunctionComponent<Props> = ({
    batteries,
    className = '',
    cycleInterval,
    droneNames,
    onOpenBattery,
    testId = TEST_ID
}) => {
    const { NO_BATTERIES } = useTranslation();

    if (batteries.length === 0) {
        return <EmptyState className={className} text={NO_BATTERIES} />;
    }

    return (
        <Wrapper className={`${styles.cardGrid} ${className}`} testId={testId}>
            {batteries.map(battery => (
                <BatteryCard
                    battery={battery}
                    cycleInterval={cycleInterval}
                    droneNames={droneNames}
                    key={battery.id}
                    onOpen={onOpenBattery}
                />
            ))}
        </Wrapper>
    );
};

export default BatteryCardGrid;
